import { useTranslation } from 'next-i18next';
import { useEffect, useState } from 'react';

import { updateStepCart } from '@/redux/slices/checkout.slice';
import { CartShippingModel } from '@/models';
import { useAppDispatch, useAppSelector } from '@/redux';
import { updateExproOrder } from '@/redux/slices/expro.slice';
import { UntypedObject } from '@/types';

import CheckboxV2 from '@/components/common/CheckboxV2';
import MillesimaPrice from '@/components/common/price/MillesimaPrice';

import styles from './WeatherHold.module.scss';
import { PRICE } from '@/constants/price';

type WeatherHoldProps = {
  weatherHold: UntypedObject;
  deliveryMode: CartShippingModel;
  isExproCheckout: boolean;
}

export const WeatherHold = ({ weatherHold, deliveryMode, isExproCheckout = false }: WeatherHoldProps) => {
  const dispatch = useAppDispatch();
  const { t } = useTranslation();

  const exproOrder = useAppSelector(({ expro }) => expro.exproOrder);
  const shippingMode = useAppSelector(({ cart }) => cart.content?.shippingMode);
  const [weatherHoldChecked, setWeatherHoldChecked] = useState(deliveryMode.weatherHoldChecked);
  const { description, price, title, wordingReprise } = weatherHold;

  useEffect(() => {
    if (shippingMode?.weatherHold && shippingMode._id === deliveryMode._id) {
      const updateDeliveryMode = {
        ...deliveryMode,
        weatherHoldChecked: weatherHoldChecked
      };
      if (isExproCheckout) {
        dispatch(updateExproOrder({
          exproOrder: {
            ...exproOrder,
            shippingMode: updateDeliveryMode
          }
        }));
      } else {
        dispatch(updateStepCart({ update: { shippingMode: updateDeliveryMode } }));
      }
    }
  }, [weatherHoldChecked]);

  return (
    <div className={styles.container} data-test-id="container">
      <div className={styles.recommend} data-test-id="recommend">{t('checkout:shipMode.recommend')}</div>
      <div className={styles.header} data-test-id="header">
        <CheckboxV2 onChange={() => setWeatherHoldChecked(!weatherHoldChecked)} checked={weatherHoldChecked} />
        <div className={styles['header-information']} data-test-id="header-information">
          <div className={styles.title} data-test-id="title">
            {title}
          </div>
          <MillesimaPrice
            value={price === 0 ? PRICE.FREE : +price}
            className={{ container: `${styles.price} ${price === 0 ? styles.free : ''}` }}
          />
        </div>
      </div>
      <p className={styles.description} data-test-id="description">
        {description}
      </p>
      <div className={styles.footer} data-test-id="footer">
        <div dangerouslySetInnerHTML={{ __html: wordingReprise }} />
      </div>
    </div>
  );
};

export default WeatherHold;
